import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';
import { Area } from '@/modules/floorplanDesign/types';

export type ActiveDistconSource = {
  id: string;
  area: Area;
  type: Area['areaType'];
  originPosition: { x: number; y: number };
};

type StoreState = {
  source: ActiveDistconSource | null;
};

type StoreAction = {
  setSource(source: ActiveDistconSource | null): void;
  reset(): void;
};

const INITIAL_STATE: StoreState = {
  source: null,
};

export const useActiveDistconStore = create<StoreState & StoreAction>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      setSource(source) {
        set({ source }, undefined, { type: 'setSource' });
      },

      reset() {
        set(INITIAL_STATE, undefined, { type: 'reset' });
      },
    }),
    { store: 'distconStore', ...DEVTOOLS_OPTIONS },
  ),
);
